export const GET_INVESTORS_START = "[Accredition Component] Get Investors Start";
export const GET_INVESTORS_FAIL = "[Accredition Component] Get Investors Fail";
export const GET_INVESTORS = "[Accredition Component] Get Investors";
export const GET_INVESTORS_SUCCESS = "[Accredition Component] Get Investors Success";
export const GET_INVESTOR = "[Accredition Component] Get Investor";
export const GET_INVESTOR_SUCCESS = "[Accredition Component] Get Investor Success";
export const ACCREDITATION_ACTION = "[Accredition Component] Acc. Action";
export const ACCREDITATION_ACTION_RESPONSE = "[Accredition Component] Acc. Action Response";
